exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".settings .wrapper-main .content form .jq-file.upload-hidden{width:150px;height:auto;border:none;border-radius:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./directives/uploadCompanyLogo/uploadCompanyLogo.scss
// module id = 503
// module chunks = 0